import { render, staticRenderFns } from "./ModalTED.vue?vue&type=template&id=2c71e6da&scoped=true"
import script from "./ModalTED.vue?vue&type=script&lang=js"
export * from "./ModalTED.vue?vue&type=script&lang=js"
import style0 from "./ModalTED.vue?vue&type=style&index=0&id=2c71e6da&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c71e6da",
  null
  
)

export default component.exports